var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"title"},[_vm._v("准备好了吗")]),_c('el-button',{on:{"click":_vm.goMap}},[_vm._v("开始😵")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }